import _ from 'lodash'
import { EntityState } from '@reduxjs/toolkit'

import { CommonState, Model } from '@/core/classes/Model'
import { SearchBulkOrdersQuery, SearchRequestOptions } from '@/core/types/request'

import { Order } from './order.model'
import { SearchResponse } from '../types/response'

export enum BulkOrderStatus {
  Accepted = 'Accepted',
  AutoAccepted = 'AutoAccepted',
  Archived = 'Archived',
  Done = 'Done',
  Pending = 'Pending',
}

export type BulkOrder = {
  _id: string
  avgOrderDuration: number
  meetingLink: string
  orders: Order[]
  status: BulkOrderStatus
  pds?: string
  startDate: string
  endDate: string
}

export type UpdateBulkOrderDto = {
  pds?: string
  status?: BulkOrderStatus
}

export type BulkOrderState = CommonState & {
  bulkOrders: EntityState<BulkOrder, BulkOrder['_id']>
}

class BulkOrderModel extends Model {
  static instance: BulkOrderModel

  static getInstance() {
    if (!BulkOrderModel.instance) {
      BulkOrderModel.instance = new BulkOrderModel('bulkOrder')
    }
    return BulkOrderModel.instance
  }

  getInitialState(): BulkOrderState {
    return _.merge({}, this.commonState, {
      bulkOrders: {
        entities: {},
        ids: [],
      },
    })
  }

  getBulkOrder = async (bulkOrderId: string) => {
    return await this.httpClient.request<BulkOrder>(`/bulk-orders/${bulkOrderId}`, 'GET')
  }

  listBulkOrders = async (query: SearchBulkOrdersQuery, options?: SearchRequestOptions) => {
    const defaultOptions = { limit: 5, order: 'ASC', skip: 0 }
    return await this.httpClient.request<SearchResponse<BulkOrder>>('/bulk-orders/query', 'POST', { query, options: _.merge({}, defaultOptions, options) })
  }

  updateBulkOrder = async (bulkOrderId: string, updateBulkOrderDto: UpdateBulkOrderDto) => {
    return await this.httpClient.request<BulkOrder>(`/bulk-orders/${bulkOrderId}`, 'PATCH', updateBulkOrderDto)
  }
}

export default BulkOrderModel.getInstance()
